export default __webpack_public_path__ + "static/media/0.4ad0e84b.png";